import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

export const initialState = {
  clientTxnOpps: null,
  isFetchingClientTxnOppsData: false,
  workflowGridNeedsToRefresh: false
}

// create slice will call createAction and createReducer for us internally
const slice = createSlice({
  name: 'clientTxnOppsSlice',
  initialState,
  reducers: {
    setClientTxnOpps: (state, action) => {
      state.clientTxnOpps = action.payload;
    },
    setIsFetchingClientTxnOppsData: (state, action) => {
      state.isFetchingClientTxnOppsData = action.payload;
    },
    setWorkflowGridNeedsToRefresh: (state, action) => {
      state.workflowGridNeedsToRefresh = action.payload;
    },

    // Redux saga actions, no reducers
    updateClientTxnOpps: { // Triggers clientTxnOppsUpdateSaga
      reducer: () => { },
      prepare: (txnOpps, actionResult) => ({ payload: { txnOpps, actionResult } })
    },
    deleteTxnOpps: () => { }, // Triggers deleteTxnOppsSaga
    reloadTxnOpps: () => { }, // Triggers reloadTxnOppsSaga
    editTxnOpp: { // Triggers reloadTxnOppsSaga
      reducer: () => { },
      prepare: (request, callback) => ({ payload: { request, callback } })
    },
    onNewTasksFromImport: () => { }, // Triggers checkWorkflowGridNeedsToRefreshSaga

    assignTasksTo: { // Triggers taskAssignmentSaga
      reducer: () => { },
      prepare: (taskType, taskIds, assignToUserId, initiatedUserId) => ({ payload: { taskType, taskIds, assignToUserId, initiatedUserId } })
    },
    unassignTasks: { // Triggers taskAssignmentSaga
      reducer: () => { },
      prepare: (taskType, taskIds, initiatedUserId) => ({ payload: { taskType, taskIds, initiatedUserId } })
    },
    terminateTxnOpps: { // Triggers terminateTxnOppsSaga
      reducer: () => { },
      prepare: (transactionOpportunityIds, reason) => ({ payload: { transactionOpportunityIds, reason } })
    },
    unterminateTxnOpps: { // Triggers terminateTxnOppsSaga
      reducer: () => { },
      prepare: (txnOppIds) => ({ payload: { txnOppIds } })
    },
    exportAllocationLogs: {
      reducer: () => { },
      prepare: (txnOppIds) => ({ payload: { txnOppIds } })
    },
    getDescriptiveFitDetails: {
      reducer: () => { },
      prepare: (txnOppIds) => ({ payload: { txnOppIds } })
    },
    updateVisibleTxnOpps: { // Triggers updateVisibleTxnOppsSaga
      reducer: () => { },
      prepare: (txnOppIds, updateType) => ({ payload: { txnOppIds, updateType } })
    },

    orderInspection: () => { }, // Triggers purchaseSaga
    refreshTxnInspection: () => { }, // Triggers purchaseSaga
    updateBidInPrism: { // Triggers purchaseSaga
      reducer: () => { },
      prepare: (txnOppIds, proformaUpdateObj) => ({ payload: { txnOppIds, proformaUpdateObj } })
    },
    syncPurchaseState: () => { }, // Triggers purchaseSaga
    runStatusOverrideSync: () => {}, // Triggers purchaseSaga
    submitPreScreenToUnderwrite: { // Triggers submitPreScreenToUnderwriteSaga
      reducer: () => { },
      prepare: (txnOppIds, callback) => ({ payload: { txnOppIds, callback } })
    }
  }
});

export default slice.reducer;

export const clientTxnOppsActions = slice.actions;

// Memoized selectors
export const clientTxnOppsSelectors = {
  clientTxnOppsSelector: createSelector(
    state => state.clientTxnOppsState.clientTxnOpps,
    clientTxnOpps => clientTxnOpps
  ),
  isFetchingClientTxnOppsDataSelector: createSelector(
    state => state.clientTxnOppsState.isFetchingClientTxnOppsData,
    isFetchingClientTxnOppsData => isFetchingClientTxnOppsData
  )
}
